const SelectContext = React.createContext({ multiple: false, value: null });
export default SelectContext;
